export const B2C_KEYS = ['leadSource', 'outcomeReason']

export const NON_B2C_KEYS = ['industry']

export const DROPDOWNS = [
  {
    name: 'Lead Source',
    pluralName: 'Lead Sources',
    key: 'leadSource',
    description: 'How do customers hear about you?',
    dropdownSurfaceId: 1,
    options: [
      {
        name: 'Google search',
      },
      {
        name: 'Referral',
      },
      {
        name: '',
      },
    ],
  },
  {
    name: 'Outcome Reason',
    dropdownSurfaceId: 1,
    pluralName: 'Outcome Reasons',
    key: 'outcomeReason',
    description:
      'When marking a business deal as "Won" or "Lost", what are some of the typical reasons why?',
    options: [
      {
        name: 'Competition',
      },
      {
        name: 'Timing',
      },
      { name: '' },
    ],
  },
  {
    name: 'Industry',
    dropdownSurfaceId: 1,
    pluralName: 'Industries',
    key: 'industry',
    description: 'What industries are your customers in?',
    options: [
      {
        name: 'Technology',
      },
      {
        name: 'Medical',
      },
      { name: '' },
    ],
  },
]
